export function localeOf(lang: string) {
  return lang === 'en' ? 'en-GB' : 'fr-FR';
}

export function formatMoney(amount: number, currency: string, lang: string) {
  const value = Number.isFinite(amount) ? amount : 0;
  try {
    return new Intl.NumberFormat(localeOf(lang), {
      style: 'currency',
      currency: currency || 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
  } catch {
    return `${value.toFixed(2)} ${currency}`;
  }
}

export function formatNumber(amount: number, lang: string) {
  const value = Number.isFinite(amount) ? amount : 0;
  return new Intl.NumberFormat(localeOf(lang), {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatDate(iso: string | null | undefined, lang: string, withTime = false) {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat(localeOf(lang), {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {}),
  }).format(date);
}

export function formatCardBrand(brand: string | null | undefined) {
  if (!brand) return 'Visa';
  const map: Record<string, string> = {
    visa: 'Visa',
    mastercard: 'Mastercard',
    unionpay: 'UnionPay',
  };
  return map[brand] ?? brand;
}